import script from "./AdminGeneratedPdfsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminGeneratedPdfsView.vue?vue&type=script&setup=true&lang=js"

import "./AdminGeneratedPdfsView.vue?vue&type=style&index=0&id=0833d7f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0833d7f0"]])

export default __exports__